import 'swiper/swiper-bundle.css';

import { Button, Image, Typography } from '@smartgift/frontend-toolkit';
import qs from 'qs';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ROUTE_PATHS } from '@hero/routes';
import { useGetCSEntries } from '@hero/services/content-stack-service/hooks';

import * as S from './style';

function StaticBanners() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: banners } = useGetCSEntries({
    entryCode: 'sgb_dashboard_home_static_banners'
  });

  return (
    <S.StaticBanners>
      <S.ImageTop>
        <Image src={banners?.entries?.[2]?.image?.url} width="100%" />
        <S.ImageTopCard>
          <S.ContentCard>
            <Typography variant="subtitle3Bold">{t('homeStaticBannersTopImageTitle')}</Typography>
            <Typography variant="caption1">{t('homeStaticBannersTopImageDescription')}</Typography>
            <Button
              onClick={() =>
                navigate(
                  `${ROUTE_PATHS.GIFT_CATALOG}?${qs.stringify({
                    categoryIds: ['808']
                  })}`
                )
              }
            >
              {t('homeStaticBannersTopButton')}
            </Button>
          </S.ContentCard>
        </S.ImageTopCard>
      </S.ImageTop>
      <S.ImageBottom>
        <S.ImageLeft>
          <Image src={banners?.entries?.[1]?.image?.url} height={240} />
          <S.ImageLeftCard>
            <S.ContentCard>
              <Typography variant="subtitle3Bold">
                {t('homeStaticBannersLeftImageTitle')}
              </Typography>
              <Typography variant="caption1">
                {t('homeStaticBannersLeftImageDescription')}
              </Typography>
              <Button
                onClick={() =>
                  navigate(
                    `${ROUTE_PATHS.GIFT_CATALOG}?${qs.stringify({
                      categoryIds: ['832']
                    })}`
                  )
                }
              >
                {t('homeStaticBannersLeftButton')}
              </Button>
            </S.ContentCard>
          </S.ImageLeftCard>
        </S.ImageLeft>
        <S.ImageRight>
          <Image src={banners?.entries?.[0]?.image?.url} height={240} />
          <S.ImageRightCard>
            <S.ContentCard>
              <Typography variant="subtitle3Bold">
                {t('homeStaticBannersRightImageTitle')}
              </Typography>
              <Typography variant="caption1">
                {t('homeStaticBannersRightImageDescription')}
              </Typography>
              <Button
                onClick={() =>
                  navigate(
                    `${ROUTE_PATHS.GIFT_CATALOG}?${qs.stringify({
                      categoryIds: ['802']
                    })}`
                  )
                }
              >
                {t('homeStaticBannersRightButton')}
              </Button>
            </S.ContentCard>
          </S.ImageRightCard>
        </S.ImageRight>
      </S.ImageBottom>
    </S.StaticBanners>
  );
}

export { StaticBanners };
